"use client";
import React, { useState } from "react";
import { Link } from "../../../navigation";
import FilterCard from "./FilterCard";
import { useTranslations } from "next-intl";

export interface ChildAssortmentFilterCardProps {
  limit?: number;
  title?: string;
  assortmentChildren?: Array<{
    _id: string;
    texts: {
      title: string;
      slug: string;
    };
  }>;
}

const ChildAssortmentFilterCard: React.FC<ChildAssortmentFilterCardProps> = ({
  limit = 20,
  title,
  assortmentChildren,
}) => {
  const t = useTranslations();

  const items = assortmentChildren?.map((child) => ({
    href: child.texts.slug,
    label: child.texts.title,
  }));

  const [itemLimit, setItemLimit] = useState(limit);
  const showMore = items?.length > itemLimit;
  const loadMore = () => {
    setItemLimit(Infinity);
  };

  if (!items?.length) {
    return null;
  }

  return (
    <FilterCard title={title}>
      <div className="d-flex flex-column gap-12px gap-lg-2 mt-2">
        {items?.slice(0, itemLimit).map((item) => (
          <div
            key={item.href}
            className="d-flex align-items-center justify-content-between"
          >
            <span className="d-flex align-items-start fs-7">
              <Link
                className="hyphens-auto link-hover"
                href={item.href}
                shallow
                prefetch={false}
              >
                {item.label}
              </Link>
            </span>
          </div>
        ))}
      </div>

      {showMore && (
        <button className="color-blue fs-8 mt-2" onClick={loadMore}>
          {t("show_more")}
        </button>
      )}
    </FilterCard>
  );
};

export default ChildAssortmentFilterCard;
